import * as React from "react"
import {Skeleton} from "@mui/material";

import { TitleWithPopover, AppTableSeeker } from "@components";
import {WEBBACK_V2_API} from "@constants";
import {useToast} from "@hooks";
import {isLoadingCommonFilters} from "@signals";
import {useAmazonPPKpisFilters} from "../@hooks";
import {checkColumn, imageSkuColumn, numberColumn, retailerColumn, skuColumn} from "./columns";


export default function AmazonPPKpisTable() {
    const { showToast } = useToast()
    const { data } = useAmazonPPKpisFilters()

    if (isLoadingCommonFilters.value) return <Skeleton variant="rectangular" height={500} />
    if (!data.length) return <></>

    const columns = [
        imageSkuColumn(),
        ...skuColumn(),
        ...retailerColumn(),
        ...numberColumn('title_match', 'Title Comparison', 2),
        ...numberColumn('image_gallery_match', 'Image Comparison', 2),
        ...numberColumn('safety_warning_match', 'Safety Warning', 2),
        ...numberColumn('min_age', 'Min Age'),
        ...numberColumn('long_desc', 'Product description Length'),
        ...numberColumn('bullet_points', 'Bullet Points'),
        ...checkColumn('from_the_brand', 'From The Brand'),
        ...checkColumn('from_the_manufacturer', 'From The Manufacturer'),
        ...numberColumn('highlight', 'Item Highlights'),
    ]

    return <AppTableSeeker
        data={data}
        title={<TitleWithPopover title="Amazon Product Page Kpis" />}
        columns={columns}
        options={{
            onDownload: () => showToast.promiseExcel(`${WEBBACK_V2_API}/custom-dash/amazon-kpis/excel`)
        }}
    />
}